// extracted by mini-css-extract-plugin
export default {"root":"Badge-modules__root__qaEZs"};